var crypto = require('crypto');

var generate_key = function() {
  // return crypto.randomBytes(16).toString('base64');
  return crypto.randomBytes(16).toString('hex');
};

export const get_session_key = () => {
  let sessionKey = sessionStorage.getItem("currentSessionKey");
  if( !sessionKey ) {
    sessionKey = generate_key();
    sessionStorage.setItem("currentSessionKey", sessionKey);
  } else {
    // console.log(sessionStorage);
  }
  return sessionKey;
}
